import script from "./LotteryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotteryCard.vue?vue&type=script&setup=true&lang=ts"

import "./LotteryCard.vue?vue&type=style&index=0&id=410e9c3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410e9c3f"]])

export default __exports__